var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMldQuickdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.518 1.5c7.562 0 13.726 5.589 13.726 12.452 0 4.767-4.068 10.274-7.11 13.726-1.56 1.767-3.944 2.795-6.451 2.795h-.329c-2.507 0-4.89-.987-6.452-2.795-3.041-3.41-7.069-8.959-7.069-13.726C10.834 7.09 16.957 1.5 24.519 1.5z",
    fill: "#fff",
    stroke: "url(#msp9uk0j8a)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.888 9.185a8.708 8.708 0 0 1 1.068 4.192c0 5.219-4.685 9.493-10.438 9.493-5.753 0-10.438-4.233-10.438-9.452 0-5.22 4.685-9.493 10.438-9.493 1.85 0 3.534.41 5.055 1.192",
    stroke: "url(#9fskl202zb)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.929 33.226v10.191c0 1.727-1.52 3.083-3.411 3.083-1.89 0-3.411-1.398-3.411-3.083V29.938",
    stroke: "url(#5od8ac328c)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.93 33.227h-4.603",
    stroke: "url(#c5yftl7pwd)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.93 35.568h-4.603",
    stroke: "url(#17frdx4jme)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "msp9uk0j8a",
    x1: 10.834,
    y1: -27.396,
    x2: 38.245,
    y2: -27.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9fskl202zb",
    x1: 14.08,
    y1: -14.97,
    x2: 34.956,
    y2: -14.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5od8ac328c",
    x1: 21.107,
    y1: 13.42,
    x2: 27.929,
    y2: 13.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c5yftl7pwd",
    x1: 23.327,
    y1: 32.229,
    x2: 27.93,
    y2: 32.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "17frdx4jme",
    x1: 23.327,
    y1: 34.571,
    x2: 27.93,
    y2: 34.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMldQuickdraw);
export default __webpack_public_path__ + "static/media/mld-quickdraw.fea830355b6b07f502dc8f8175c77709.svg";
export { ForwardRef as ReactComponent };